"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/UYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_241)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_241`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.719971 0H35.28V24H-0.719971V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.719971 2.66675H35.28V5.33341H-0.719971V2.66675ZM-0.719971 8.00008H35.28V10.6667H-0.719971V8.00008ZM-0.719971 13.3334H35.28V16.0001H-0.719971V13.3334ZM-0.719971 18.6667H35.28V21.3334H-0.719971V18.6667Z",
					fill: "#0038A8"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.719971 0H17.28V13.3333H-0.719971V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.28353 9.73328L7.22388 11.3192L6.95721 9.43152L5.31511 10.3999L5.89054 8.5824L3.98177 8.73679L5.28704 7.34731L3.5116 6.66661L5.29405 5.98591L3.98177 4.59643L5.88353 4.75784L5.30809 2.94029L6.95019 3.90872L7.22388 2.021L8.28353 3.60696L9.34317 2.021L9.60984 3.90872L11.2519 2.94029L10.6765 4.75784L12.5783 4.60345L11.273 5.99293L13.0555 6.67363L11.273 7.35433L12.5783 8.7438L10.6765 8.58942L11.2519 10.407L9.60984 9.43854L9.33616 11.3263L8.28353 9.73328ZM8.28353 9.69819C9.96072 9.76135 11.3712 8.4631 11.4344 6.78591C11.4976 5.10872 10.1993 3.69819 8.52212 3.63503H8.28353C6.60633 3.69117 5.29405 5.09468 5.35019 6.76486C5.3923 8.36486 6.68353 9.64907 8.28353 9.69819ZM8.28353 8.95433C6.96423 8.95433 5.89756 7.88766 5.89756 6.56836C5.89756 5.24907 6.96423 4.1824 8.28353 4.1824C9.60282 4.1824 10.6695 5.24907 10.6695 6.56836C10.6695 7.88766 9.59581 8.95433 8.28353 8.95433Z",
					fill: "#FED443"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_241`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as UYFlag };
